const entity = {
    create_failed: '{{name}}の作成に失敗しました。',
    not_exists: '{{name}}は存在しません。',
    not_exists_with_id: 'IDが`{{id}}`の{{name}}は存在しません。',
    not_found: 'リソースが存在しません。',
};
export default entity;
